import { Injectable } from '@angular/core';
import { IPreCadastro } from '@app/modules/cliente/models/pre_cadastro.model';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IEntityPagination } from 'viggo-sistemas-core-web/modules/core/model/entity.model';
import { IHistoricoMovimentacao } from '../model/historico_movimentacao.model';

@Injectable()
export class HistoricoMovimentacaoService extends EntityService<IPreCadastro> {
  id: number;
  constructor(
    protected configService: ConfigService,
    tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: `parceiro`
    });
  }

  gerarHistorico(id: string, page: number, page_size: number): Observable<any> {
    const url = `${this.baseURL}/${id}/historico_movimentacao?page=${page}&order_by=pre_cadastro.nome_razao_social&page_size=${page_size}&require_pagination=true`;
    return this.http
      .get(url, {
        headers: this.getHeader()
      })
      .pipe(
        map(data => {
          let data_array = data['parceiro'][
            'movimentacoes'
          ] as IEntityPagination<IHistoricoMovimentacao>[];
          return {
            data: data_array,
            pagination: data['parceiro']['pagination']
          };
        }),
        catchError(this.handleError)
      );
  }
}
